import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import utils from '@/utils/utils';
import dd from '@/utils/dd';
import hb from '@/assets/hb.png';
import { base } from '@/services/api/_base';
import "./style.scss";

function RedPacket(props: any) {
  const { id, list, compId, mark, pId, mallTest, _pvMoudel, _adMoudel } = props;

  const clickRedPacket = (data: any, positionId: number) => {
    window.location.href = base.isProduct
      ? `https://mcar.mall.autohome.com.cn/frontEndPageStatic/productDetail/index.html?itemId=${data.biz_id}&sourceid=200002&test=2021&mallTest=${mallTest}${_pvMoudel}${_adMoudel}`
      : `http://pbl.terra.corpautohome.com/frontEndPageStatic/productDetail/index.html?itemId=${data.biz_id}&sourceid=200002&test=20211230&mallTest=${mallTest}${_pvMoudel}${_adMoudel}`;
    // 点击埋点
    let extendParams = {
      ...dd.ep,
      providerId: pId,
      brandId: data.cms_brand_ids,
      // 组件id
      compId,
      positionId,
      // 商品id和外层的id一样
      goodId: data.biz_id,
      mallTest,
    };
    extendParams = utils.formatParams(extendParams);
    utils.pvTrackLogger(
      "click",
      "ec_topic_mall_hbshangpin_click",
      dd.baseParams,
      extendParams
    );
  };

  useEffect(() => {
    if (list.length > 0 && mark.pageType === "mall") {
      // 曝光埋点
      list.forEach((v: any, k: number) => {
        let extendParams = {
          ...dd.ep,
          providerId: pId,
          brandId: v.data.cms_brand_ids,
          compId,
          positionId: k + 1,
          goodId: v.id,
          mallTest,
        };
        extendParams = utils.formatParams(extendParams);
        utils.pvTrackLogger(
          "show",
          "ec_topic_mall_hbshangpin_show",
          dd.baseParams,
          extendParams
        );
      });
    }
  }, [list, JSON.stringify(mark)]);

  return (
    <div key={id} className="tabHome-item slide-box tabHome-item-HB">
      {list.map((v: any, k: number) => {
        const { data } = v;
        const { commodity_type, sale_price, worth } = data;
        return (
          <div
            key={v.id}
            className="slide-item"
            onClick={() => clickRedPacket(data, k + 1)}
          >
            <img id={`hbfm${k}`} src={hb} />
            <span className="slide-content">
              <span>
                ￥
                <span className="price">
                  {commodity_type && Number(commodity_type) === 2
                    ? `${worth}`
                    : `${sale_price}`}
                </span>
              </span>
              <span className="title">{`${data.cms_series_names}`}</span>
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default RedPacket;
